import { DraggableLocation } from "@hello-pangea/dnd";
import { IColumn, IColumnMap, IItem, IItemMap } from "./types";

function reorder<TItem>(
  list: TItem[],
  startIndex: number,
  endIndex: number
): TItem[] {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export default reorder;

interface ReorderItemMapArgs {
  itemMap: IItemMap;
  source: DraggableLocation;
  destination: DraggableLocation;
}

export interface ReorderItemMapResult {
  itemMap: IItemMap;
}

export const reorderItemMap = ({
  itemMap,
  source,
  destination,
}: ReorderItemMapArgs): ReorderItemMapResult => {
  const current: IItem[] = [...itemMap[source.droppableId]];
  const next: IItem[] = [...itemMap[destination.droppableId]];
  const target: IItem = current[source.index];

  // moving to same list
  if (source.droppableId === destination.droppableId) {
    const reordered: IItem[] = reorder(
      current,
      source.index,
      destination.index
    );
    const result: IItemMap = {
      ...itemMap,
      [source.droppableId]: reordered,
    };
    return {
      itemMap: result,
    };
  }

  // moving to different list

  // remove from original
  current.splice(source.index, 1);
  // insert into next
  next.splice(destination.index, 0, target);

  const result: IItemMap = {
    ...itemMap,
    [source.droppableId]: current,
    [destination.droppableId]: next,
  };

  return {
    itemMap: result,
  };
};

export const reorderColumnMap = ({
  columnMap,
  source,
  destination,
}: {
  columnMap: IColumnMap;
  source: DraggableLocation;
  destination: DraggableLocation;
}) => {
  const sourceColumn: IColumn = columnMap[source.droppableId];
  const destinationColumn: IColumn = columnMap[destination.droppableId];

  const current: IItem[] = [...sourceColumn.items];
  const next: IItem[] = [...destinationColumn.items];
  const target: IItem = current[source.index];

  // same column
  if (source.droppableId === destination.droppableId) {
    const reordered: IItem[] = reorder(
      current,
      source.index,
      destination.index
    );
    const result: IColumnMap = {
      ...columnMap,
      [source.droppableId]: {
        ...sourceColumn,
        items: reordered,
      },
    };
    return {
      columnMap: result,
    };
  }

  // different column
  const updatedSourceItems: IItem[] = current.filter(
    (_, index) => index !== source.index
  );
  next.splice(destination.index, 0, target);
  const resultColumnMap: IColumnMap = {
    ...columnMap,
    [source.droppableId]: {
      ...sourceColumn,
      items: updatedSourceItems,
    },
    [destination.droppableId]: {
      ...destinationColumn,
      items: next,
    },
  };

  return {
    columnMap: resultColumnMap,
  };
};
